import * as React from "react";

function Section3() {
  return (
    <div className="flex flex-col py-6 px-5">
      <div className="self-center text-5xl font-semibold tracking-wide text-center capitalize leading-[52.08px] text-zinc-800">
        Features
      </div>
      <div className="mt-8 w-full max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow justify-center text-center max-md:mt-10">
              <div className="flex flex-col justify-center p-6 rounded-md border border-gray-200 border-solid max-md:px-5">
                <img
                  loading="lazy"
                  srcSet="..."
                  className="self-center aspect-[0.85] w-[85px]"
                />
                <div className="mt-5 text-2xl font-medium leading-10 capitalize text-zinc-700">
                  Pro support
                </div>
                <div className="mt-2.5 text-sm leading-6 text-slate-500">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore.
                </div>
                <div className="justify-center items-center px-8 py-3 mt-8 text-base font-bold leading-6 text-white capitalize bg-cyan-700 rounded-md max-md:px-5">
                  Read more
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow justify-center text-center max-md:mt-10">
              <div className="flex flex-col justify-center p-6 rounded-md border border-gray-200 border-solid max-md:px-5">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/3b2b93881906fb44bb1b05da474565f181c542dca3190b2a4608be745c7b8a3d?"
                  className="self-center max-w-full aspect-[1.2] w-[126px]"
                />
                <div className="mt-5 text-2xl font-medium leading-10 capitalize text-zinc-700">
                  Unique design
                </div>
                <div className="mt-2.5 text-sm leading-6 text-slate-500">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore.
                </div>
                <div className="justify-center items-center px-8 py-3 mt-8 text-base font-bold leading-6 text-white capitalize bg-cyan-700 rounded-md max-md:px-5">
                  Read more
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow justify-center text-center max-md:mt-10">
              <div className="flex flex-col justify-center p-6 rounded-md border border-gray-200 border-solid max-md:px-5">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/8c6b8c7af92c025ef5dca805014bb0613bdfacfe7b8adaf47de69f185f28c0ec?"
                  className="self-center max-w-full aspect-[0.99] w-[101px]"
                />
                <div className="mt-5 text-2xl font-medium leading-10 capitalize text-zinc-700">
                  Future Proof
                </div>
                <div className="mt-2.5 text-sm leading-6 text-slate-500">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore.
                </div>
                <div className="justify-center items-center px-8 py-3 mt-8 text-base font-bold leading-6 text-white capitalize bg-cyan-700 rounded-md max-md:px-5">
                  Read more
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col ml-5 w-3/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col grow justify-center text-center max-md:mt-10">
              <div className="flex flex-col justify-center p-6 rounded-md border border-gray-200 border-solid max-md:px-5">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e0ee1f18ffd054b9cfef795e575398a585adc96d3c174b0bc649999f8346865f?"
                  className="self-center max-w-full aspect-[1.23] w-[113px]"
                />
                <div className="mt-6 text-2xl font-medium leading-10 capitalize text-zinc-700">
                  Pixel Perfect
                </div>
                <div className="mt-2.5 text-sm leading-6 text-slate-500">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore.
                </div>
                <div className="justify-center items-center px-8 py-3 mt-8 text-base font-bold leading-6 text-white capitalize bg-cyan-700 rounded-md max-md:px-5">
                  Read more
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Section3;
